import { Suspense, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

import PaylinqLogo from "src/images/paylinq-logo.png";
import { useAuth } from "src/providers/AuthProvider";
import DashboardContext from "src/context/DashboardContext";
import CustomModal from "src/components/CustomModal";
import UpdatePassword from "src/components/modals/UpdatePassword";
import { Sheet, SheetContent } from "src/components/ui/sheet";
import Sidebar, { SidebarContent, useSidebarCollapsed } from "./Sidebar";
import PageHeader from "./PageHeader";
import GlobalSearch from "./GlobalSearch";

const PageLoader = () => (
	<div className="page_loading">
		<img src={PaylinqLogo} alt="Loading" />
		<br />
		<p>Loading...</p>
	</div>
);

const ProtectedRoute = () => {
	const { isAuthenticated, user } = useAuth();
	const { collapsed, setCollapsed } = useSidebarCollapsed();

	const [mobileNavOpen, setMobileNavOpen] = useState(false);
	const [searchOpen, setSearchOpen] = useState(false);
	const [isDefaultPassword, setIsDefaultPassword] = useState(Boolean(user?.has_default_password));

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<DashboardContext>
			<div className="tw-flex tw-min-h-dvh tw-bg-bg">
				<Sidebar collapsed={collapsed} onToggleCollapse={() => setCollapsed((prev) => !prev)} />

				{/* Below `lg` the sidebar becomes a drawer (responsive convention, D3) */}
				<Sheet open={mobileNavOpen} onOpenChange={setMobileNavOpen}>
					<SheetContent side="left" className="tw-w-[262px] tw-border-0 tw-p-0 sm:tw-max-w-[262px]">
						<SidebarContent collapsed={false} onNavigate={() => setMobileNavOpen(false)} />
					</SheetContent>
				</Sheet>

				<div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">
					<PageHeader onOpenMobileNav={() => setMobileNavOpen(true)} onOpenSearch={() => setSearchOpen(true)} />

					<main className="tw-flex-1 tw-px-4 tw-py-6 sm:tw-px-6 lg:tw-px-7 lg:tw-py-7">
						<Suspense fallback={<PageLoader />}>
							<Outlet />
							<CustomModal title="Update Default Password" open={isDefaultPassword} onOpenChange={setIsDefaultPassword}>
								<UpdatePassword isForDefault />
							</CustomModal>
						</Suspense>
					</main>
				</div>

				<GlobalSearch open={searchOpen} onOpenChange={setSearchOpen} />
			</div>
		</DashboardContext>
	);
};

export default ProtectedRoute;
